import { ROUTE_NAMES } from "@root/constants";
import { selectAdminSidebar } from "@root/store/selectors/admin/app";
import { updateSidebar } from "@root/store/slices/admin";
import { logout, getUserProfile } from "@root/store/thunks";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useAdmin from "./useAdmin";
import useMediaQ from "./useMediaQ";
import { adminGetProfile } from "@root/store/thunks/admin/auth";
import { MessageIcon } from "@root/assets/icons/messageIcon";
import { useTranslation } from "react-i18next";
import { LogoutIcon } from "@root/assets/icons";
import { useGlobalContext } from "@root/context/global-context";
import { selectProfile } from "@root/store/selectors/entities";
import useCustomTheme from "./useCustomTheme";

function useAdminSidebar() {
  const { pathname } = useLocation();
  const { isDarkTheme } = useCustomTheme();
  const { isSidebarOpen, setIsSidebarOpen } = useGlobalContext();
  const [logoutPopup, setLogoutPopup] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const isOpen: boolean = useSelector(selectAdminSidebar);
  const { md_900 } = useMediaQ();
  const navigate = useNavigate();
  const { translate } = useAdmin({});
  const { t } = useTranslation("common");
  const profileData = useSelector(selectProfile);

  const setIsOpen = (value: boolean) => {
    dispatch(updateSidebar(value));
  };

  useEffect(() => {
    if (!md_900 && isOpen) {
      setIsOpen(false);
    }
    if (md_900) {
      setIsOpen(true);
    }
  }, [md_900]);

  useEffect(() => {
    dispatch(adminGetProfile({}));
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  }, [pathname]);

  const sidebarItems = [
    {
      title: translate("admin.userManagement"),
      icon: MessageIcon({ color: "#1250F9" }),
      activeIcon: MessageIcon({ color: "#1250F9" }),
      routes: [ROUTE_NAMES.ADMIN_USERS_MANAGMENT],
      onClick: () => navigate(ROUTE_NAMES.ADMIN_USERS_MANAGMENT),
    },
    // Temporarily hidden - branding menu item
    // {
    //   title: translate("admin.branding.title"),
    //   icon: MessageIcon({ color: "#1250F9" }),
    //   activeIcon: MessageIcon({ color: "#1250F9" }),
    //   routes: [ROUTE_NAMES.ADMIN_BRANDING],
    //   onClick: () => navigate(ROUTE_NAMES.ADMIN_BRANDING),
    // },

    {
      type: "hr",
      onClick: () => null,
    },
  ];

  const adminLogoutHandler: any = async () => {
    dispatch(logout({}));
    navigate(ROUTE_NAMES.HOME);
  };

  const menuItemsList = [
    {
      title: t("sideMenu.Logout"),
      icon: LogoutIcon({ rotate: "180deg" }),
      onClick: () => setLogoutPopup(true),
      routes: [],
    },
  ];

  return {
    sidebarItems,
    pathname,
    isOpen,
    setIsOpen,
    isDarkTheme,
    menuItemsList,
    logoutPopup,
    setLogoutPopup,
    md_900,
    profileData,
    adminLogoutHandler,
    isMenuOpen,
    setIsMenuOpen,
  };
}

export default useAdminSidebar;